module.exports = __webpack_public_path__ + "img/gg.852fdd82.svg";